import Inputmask from 'inputmask/dist/inputmask.es6'
import { parseTimeToUnixFormat } from '@/helpers/dateHelper'

export function maskTimeDuration(element, { limitDay = false, timestamp = false } = {}) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    let opt = {
        clearMaskOnLostFocus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
        onUnMask(maskedValue, unmaskedValue) {
            if (timestamp) {
                return unmaskedValue ? parseTimeToUnixFormat(maskedValue.replaceAll('_', '0')) : unmaskedValue
            }

            return unmaskedValue ? maskedValue : unmaskedValue
        }
    }

    if (limitDay) {
        opt.alias = 'datetime'
        opt.inputFormat = 'H2:MM'
        opt.max = '23:59'
        opt.placeholder = '__:__'
    } else {
        opt.regex = '\\d{1,3}:[0-5][0-9]'
    }

    return new Inputmask(opt).mask(element)
}

export function maskHourDecimal(element) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    return new Inputmask({
        mask: '9{1,}.99',
        clearMaskOnLostFocus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
        onUnMask: function(maskedValue, unmaskedValue) {
            return unmaskedValue ? maskedValue : unmaskedValue
        },
    }).mask(element)
}

export function maskPercent(element) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    return new Inputmask('integer', {
        min: '0',
        max: '100',
        suffix: '%',
        placeholder: '',
        clearMaskOnLostFocus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(element)
}

export function maskInputPhone(element) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    return new Inputmask({
        mask: '(99) 9999[9]-9999',
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(element)
}

export function formatPhone(value)
{
    return Inputmask.format(value, { mask: '(99) 9999[9]-9999' })
}

export function maskPrice(element) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    return new Inputmask({
        alias: 'currency',
        groupSeparator: '.',
        prefix: "R$ ",
        clearMaskOnLostFocus: false,
        removeMaskOnSubmit: true,
    }).mask(element)
}

export function maskCreditCard(element) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    return new Inputmask({
        mask: '9999 9999 9999 9999',
        placeholder: '',
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(element)
}

export function maskCpf(element) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    return new Inputmask({
        mask: '999.999.999-99',
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(element)
}

export function maskCnpj(element) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    return new Inputmask({
        mask: '99.999.999/9999-99',
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(element)
}

export function maskCep(element) {
    if (!element instanceof Element) {
        element = document.querySelectorAll(element)
    }

    return new Inputmask({
        mask: '99999-999',
        placeholder: '',
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(element)
}

export function formatCep(value)
{
    return Inputmask.format(value, { mask: '99999-999' })
}

export default Inputmask
